import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Auth from './views/Auth.vue'
import store from './store'

Vue.use(Router)

const router = new Router({
  routes: [
    { path: '/', name: 'home', component: Home, meta: { requiresAuth: true}},
    { path: '/auth', name: 'auth', component: Auth },
  ]
})

router.beforeResolve((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
      if (store.state.deviceSecret)
      {
          next()
      }
      else
      {
        next({
            path: '/auth'
        });    
      }
      
      
    /*  
    Vue.prototype.$Amplify.Auth.currentAuthenticatedUser().then(data => {
      if (data && data.signInUserSession) {
        //user = data;
      }
      next()
    }).catch(() => {
      
      next({
        path: '/auth'
      });
    });
    */
  }
  next()
})

export default router